<template>
  <!-- eslint-disable max-len -->
  <div class="card fake blocked">
    <div class="card-body">
      <section id="OmnichannelOverviewEcommerceInStore">
        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <h2 class="card-title d-flex align-items-center">
                <i class="icon icon-ecommerce"></i>
                <span>{{ $t('ecommerce') }}</span>
              </h2>
            </div>
            <div class="row">
              <div class="col-sm-6 col-xl-3">
                <h3 class="chart-title">{{ $t('unique-users') }}</h3>
                <span class="value data-value color-oto-ecommerce">{{ $_formatDecimal(totalUsers) }}</span>
              </div>
              <div class="col-sm-6 col-xl-4">
                <h3 class="chart-title">{{ $t('identified-users') }}</h3>
                <span class="value data-value color-oto-ecommerce">{{ $_formatDecimal(identifiedUsers) }}</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row justify-content-end">
              <h2 class="card-title d-flex align-items-center">
                <i class="icon icon-in-store"></i>
                <span>{{ $tc('in-store') }}</span>
              </h2>
            </div>
            <div class="row justify-content-end text-right">
              <div class="col-sm-6 col-xl-3">
                <h3 class="chart-title">{{ $t('visits') }}</h3>
                <span class="value data-value color-purple-200">{{ $_formatDecimal(purchases) }}</span>
              </div>
              <div class="col-sm-6 col-xl-4">
                <h3 class="chart-title">{{ $t('purchases-identified') }}</h3>
                <span class="value data-value color-purple-200">{{ $_formatDecimal(identifiedPurchases) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-xl-center justify-content-sm-between row-graphic">
          <div class="col-sm-3 col-xl-2 info order-sm-1 order-xl-1">
            <span class="chart-title">{{ $t('match-rate') }}</span>
            <div class="bar" :class="'bar-' + usersMatchRate"></div>
            <span class="percent data-value color-oto-ecommerce">{{ $_formatNumber(usersMatchRate, '0%') }}</span>
          </div>
          <div class="col-sm-12 col-xl-8 order-sm-3 order-xl-2">
            <svg
              id="Id_On_Id_Off"
              data-name="Id On + Id Off"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="645"
              height="55.781"
              viewBox="0 0 645 55.781"
            >
              <defs>
                <filter id="filter" x="290.5" y="0.562" width="55" height="55.219" filterUnits="userSpaceOnUse">
                  <feImage
                    preserveAspectRatio="none"
                    x="290.5"
                    y="0.5620000000000118"
                    width="55"
                    height="55.219"
                    result="image"
                    xlink:href="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTUiIGhlaWdodD0iNTUuMjE5IiB2aWV3Qm94PSIwIDAgNTUgNTUuMjE5Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiB1cmwoI2xpbmVhci1ncmFkaWVudCk7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeTE9IjI3LjYwOSIgeDI9IjU1IiB5Mj0iMjcuNjA5IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iLTAuMjUiIHN0b3AtY29sb3I9IiM5ZjE4ZGUiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxLjI1IiBzdG9wLWNvbG9yPSIjNTJhMWYwIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI1NSIgaGVpZ2h0PSI1NS4yMTkiLz4KPC9zdmc+Cg=="
                  />
                  <feComposite result="composite" operator="in" in2="SourceGraphic" />
                  <feBlend result="blend" in2="SourceGraphic" />
                </filter>
              </defs>
              <g id="Id_on" data-name="Id on">
                <rect id="linha" class="cls-1" y="26.812" width="645" height="1" />
                <path
                  id="blue-database.png"
                  class="cls-2"
                  d="M795.8,630.362c-0.888-3.588-7.5-6.282-19.055-6.282s-18.167,3.53-19.054,7.118a0.873,0.873,0,0,0-.112.411v30.949a0.841,0.841,0,0,0,.09.377c0.9,4.094,9.006,7.151,19.076,7.151,10.048,0,18.136-3.044,19.071-7.124a0.885,0.885,0,0,0,.1-0.4V631.609A7.877,7.877,0,0,0,795.8,630.362Zm-1.482,22.982a2.372,2.372,0,0,1-.089.3,2.441,2.441,0,0,1-.11.248,2.867,2.867,0,0,1-.177.309c-0.05.078-.108,0.154-0.168,0.232a4.277,4.277,0,0,1-.278.327c-0.062.066-.13,0.132-0.2,0.2-0.126.12-.257-0.6-0.4-0.48-0.062.051-.13,0.937-0.2,0.987-0.173.13-.354,0.26-0.552,0.387-0.052.034-.109,0.067-0.163,0.1-0.228.14-.467,0.28-0.724,0.415-0.033.018-.068,0.035-0.1,0.051-0.287.148-.587,0.294-0.909,0.434l-0.027.012a27.718,27.718,0,0,1-6.564,1.815l-0.039.006q-0.756.121-1.553,0.216c-0.087.011-.178,0.017-0.265,0.028-0.464.052-.933,0.1-1.416,0.139-0.221.018-.453,0.026-0.677,0.041-0.364.024-.723,0.05-1.1,0.063-0.609.022-1.23,0.035-1.864,0.035s-1.255-.013-1.864-0.037c-0.373-.014-0.732-0.041-1.1-0.063-0.224-.014-0.456-0.024-0.677-0.042-0.483-.038-0.952-0.086-1.416-0.139-0.087-.01-0.178-0.017-0.265-0.027-0.531-.063-1.049-0.136-1.553-0.216l-0.039-.007a27.684,27.684,0,0,1-6.564-1.815l-0.027-.011c-0.321-.141-0.623-0.286-0.909-0.434-0.033-.018-0.069-0.034-0.1-0.051-0.257-.136-0.5-0.275-0.724-0.416-0.054-.034-0.111-0.066-0.163-0.1-0.2-.128-0.379-0.257-0.552-0.388-0.066-.05-0.135-0.1-0.2-0.15-0.147-.118-0.278-0.237-0.4-0.357-0.068-.065-0.137-0.13-0.2-0.2a4.1,4.1,0,0,1-.278-0.328c-0.06-.077-0.118-0.154-0.168-0.232a3.034,3.034,0,0,1-.177-0.308,2.362,2.362,0,0,1-.11-0.249,2.168,2.168,0,0,1-.089-0.3,1.982,1.982,0,0,1-.06-0.4,1.907,1.907,0,0,1,.024-0.283,0.9,0.9,0,0,0-.024-0.373v-7.046c0.022,0.022.049,0.043,0.071,0.065,0.167,0.16.337,0.32,0.529,0.474,2.888,2.383,8.663,4.235,17.033,4.235,8.335,0,14.1-1.837,17-4.206,0.232-.184.44,0.463,0.637,0.27v6.208a0.9,0.9,0,0,0-.023.373,1.906,1.906,0,0,1,.023.283A1.953,1.953,0,0,1,794.321,653.344Zm0.06-18.981v7.046a0.9,0.9,0,0,0-.023.373,1.906,1.906,0,0,1,.023.283,1.963,1.963,0,0,1-.06.4,2.372,2.372,0,0,1-.089.3,2.347,2.347,0,0,1-.11.248,2.867,2.867,0,0,1-.177.309c-0.05.078-.108,0.155-0.168,0.231a4.1,4.1,0,0,1-.278.328c-0.062.067-.13,0.132-0.2,0.2-0.126.119-.257,0.238-0.4,0.356-0.062.051-.13,0.1-0.2,0.151-0.173.13-.354,0.26-0.552,0.387-0.052.034-.109,0.067-0.163,0.1-0.228.141-.467,0.28-0.724,0.416-0.033.018-.068,0.034-0.1,0.052-0.287.147-.587,0.293-0.909,0.433l-0.027.012a27.765,27.765,0,0,1-6.564,1.815l-0.039.006q-0.756.121-1.553,0.217c-0.087.009-.178,0.016-0.265,0.027-0.464.052-.933,0.1-1.416,0.139-0.221.018-.453,0.026-0.677,0.041-0.364.024-.723,0.049-1.1,0.064-0.609.02-1.23,0.034-1.864,0.034s-1.255-.014-1.864-0.037c-0.373-.014-0.732-0.041-1.1-0.064-0.224-.014-0.456-0.023-0.677-0.04-0.483-.039-0.952-0.088-1.416-0.14-0.087-.01-0.178-0.017-0.265-0.027q-0.8-.1-1.553-0.217l-0.039,0a27.827,27.827,0,0,1-6.564-1.815l-0.027-.012c-0.321-.141-0.623-0.286-0.909-0.434-0.033-.018-0.069-0.035-0.1-0.052-0.257-.135-0.5-0.273-0.724-0.415-0.054-.034-0.111-0.066-0.163-0.1-0.2-.127-0.379-0.256-0.552-0.387-0.066-.05-0.135-0.1-0.2-0.15-0.147-.118-0.278-0.237-0.4-0.357-0.068-.065-0.137-0.13-0.2-0.2a4.287,4.287,0,0,1-.278-0.328c-0.06-.077-0.118-0.154-0.168-0.232a3.147,3.147,0,0,1-.177-0.308,2.544,2.544,0,0,1-.11-0.248,2.193,2.193,0,0,1-.089-0.305,1.973,1.973,0,0,1-.06-0.4,1.907,1.907,0,0,1,.024-0.283,0.9,0.9,0,0,0-.024-0.373V635.2c0.092,0.091.2-.656,0.3-0.566,0.055,0.05.107,0.1,0.165,0.151,0.23,0.2.478,0.392,0.747,0.582,0.056,0.039.119,0.078,0.177,0.117q0.339,0.229.715,0.45c0.093,0.054.185,0.108,0.281,0.161q0.42,0.234.883,0.454c0.05,0.024.1,0.049,0.148,0.073,0.359,0.166.741,0.325,1.138,0.479,0.11,0.042.225,0.083,0.337,0.124,0.316,0.117.643,0.228,0.981,0.336,0.122,0.038.242,0.078,0.366,0.115,0.449,0.136.912,0.265,1.4,0.383,0.067,0.017.139,0.031,0.206,0.047,0.429,0.1.874,0.2,1.331,0.285,0.154,0.03.312,0.058,0.469,0.087q0.652,0.117,1.342.214c0.118,0.016.231,0.036,0.351,0.052q0.855,0.112,1.767.195c0.149,0.013.3,0.023,0.457,0.035q0.727,0.057,1.488.095l0.558,0.026c0.661,0.025,1.334.042,2.031,0.042s1.371-.017,2.032-0.042l0.557-.026q0.762-.037,1.489-0.095c0.152-.013.307-0.022,0.457-0.035q0.91-.081,1.767-0.195c0.12-.016.232-0.036,0.351-0.052q0.689-.1,1.341-0.214c0.158-.029.315-0.057,0.47-0.087,0.457-.089.9-0.184,1.33-0.285l0.207-.047c0.486-.118.949-0.248,1.4-0.383,0.125-.038.245-0.077,0.367-0.115,0.338-.108.664-0.219,0.98-0.336,0.113-.041.228-0.082,0.338-0.124,0.4-.154.779-0.313,1.138-0.479,0.051-.024.1-0.049,0.148-0.073,0.309-.148.6-0.3,0.882-0.454,0.1-.053.19-0.107,0.282-0.161q0.377-.219.714-0.45c0.059-.039.121-0.078,0.177-0.117,0.27-.19.518-0.384,0.748-0.582,0.057-.051.109-0.1,0.165-0.151C794.184,634.544,794.289,634.454,794.381,634.363Zm-17.633-8.61c10.392,0,17.633,3.306,17.633,6.274s-7.241,5.437-17.633,5.437-17.633-2.469-17.633-5.437S766.356,625.753,776.748,625.753Zm17.633,36.556a1.08,1.08,0,0,0-.024.113c-0.435,2.894-7.614,5.991-17.609,5.991s-17.174-3.1-17.608-5.991a0.96,0.96,0,0,0-.025-0.109v-6.2c0.022,0.022.049,0.043,0.071,0.064,0.167,0.161.337,0.321,0.529,0.475,2.888,2.383,8.663,4.235,17.033,4.235,8.335,0,14.1-1.837,17-4.206,0.232-.184.44-1.21,0.637-1.4v7.033Z"
                  transform="translate(-243 -621)"
                />
                <text
                  id="Identified_Offline"
                  data-name="Identified Offline"
                  class="cls-3"
                  transform="translate(429.725 15.324) scale(0.696 0.697)"
                >
                  {{ $t('identified-offline') }}
                </text>
              </g>
              <g id="_79_" data-name="79%">
                <rect id="linha-2" data-name="linha" class="cls-4" x="345" y="25.812" width="170" height="3" />
                <rect id="linha-3" data-name="linha" class="cls-5" x="122" y="25.812" width="169" height="3" />
                <circle id="bolinha_match" data-name="bolinha match" class="cls-6" cx="318" cy="28.171" r="27.5" />
                <text id="_79_2" data-name="79%" class="cls-7" transform="translate(318.573 33.535) scale(0.673 0.675)">
                  {{ $_formatNumber(omniMatchRate, '0%') }}
                </text>
              </g>
              <g id="Id_off" data-name="Id off">
                <path
                  id="purple-database.png"
                  class="cls-8"
                  d="M364.8,630.362c-0.888-3.588-7.5-6.282-19.055-6.282s-18.167,3.53-19.054,7.118a0.873,0.873,0,0,0-.112.411v30.949a0.841,0.841,0,0,0,.09.377c0.905,4.094,9.005,7.151,19.076,7.151,10.048,0,18.135-3.044,19.071-7.124a0.885,0.885,0,0,0,.095-0.4V631.609A7.878,7.878,0,0,0,364.8,630.362Zm-1.482,22.982a2.372,2.372,0,0,1-.089.3,2.441,2.441,0,0,1-.11.248,2.867,2.867,0,0,1-.177.309c-0.051.078-.108,0.154-0.168,0.232a4.277,4.277,0,0,1-.278.327c-0.062.066-.13,0.132-0.2,0.2-0.125.12-.256-0.6-0.4-0.48-0.063.051-.13,0.937-0.2,0.987-0.173.13-.354,0.26-0.553,0.387-0.052.034-.108,0.067-0.162,0.1-0.229.14-.467,0.28-0.724,0.415q-0.051.027-.1,0.051c-0.287.148-.588,0.294-0.909,0.434l-0.027.012a27.731,27.731,0,0,1-6.564,1.815l-0.039.006q-0.757.121-1.553,0.216c-0.087.011-.178,0.017-0.266,0.028-0.463.052-.933,0.1-1.416,0.139-0.22.018-.452,0.026-0.676,0.041-0.364.024-.724,0.05-1.1,0.063-0.609.022-1.23,0.035-1.864,0.035s-1.255-.013-1.864-0.037c-0.373-.014-0.732-0.041-1.1-0.063-0.225-.014-0.456-0.024-0.677-0.042-0.483-.038-0.952-0.086-1.416-0.139-0.087-.01-0.178-0.017-0.265-0.027-0.531-.063-1.049-0.136-1.553-0.216l-0.04-.007a27.661,27.661,0,0,1-6.563-1.815l-0.027-.011c-0.322-.141-0.623-0.286-0.91-0.434-0.033-.018-0.068-0.034-0.1-0.051-0.257-.136-0.5-0.275-0.724-0.416-0.054-.034-0.111-0.066-0.163-0.1-0.2-.128-0.379-0.257-0.553-0.388-0.065-.05-0.134-0.1-0.2-0.15-0.146-.118-0.277-0.237-0.4-0.357-0.068-.065-0.137-0.13-0.2-0.2-0.1-.109-0.193-0.217-0.279-0.328-0.059-.077-0.117-0.154-0.168-0.232a3.021,3.021,0,0,1-.176-0.308,2.362,2.362,0,0,1-.11-0.249,2.041,2.041,0,0,1-.089-0.3,1.491,1.491,0,0,1-.036-0.686,0.917,0.917,0,0,0-.024-0.373v-7.046c0.021,0.022.048,0.043,0.07,0.065,0.168,0.16.338,0.32,0.53,0.474,2.888,2.383,8.663,4.235,17.033,4.235,8.335,0,14.1-1.837,17-4.206,0.232-.184.44,0.463,0.637,0.27v6.208a0.917,0.917,0,0,0-.024.373,1.782,1.782,0,0,1,.024.283A1.953,1.953,0,0,1,363.316,653.344Zm0.06-18.981v7.046a0.918,0.918,0,0,0-.024.373,1.782,1.782,0,0,1,.024.283,1.963,1.963,0,0,1-.06.4,2.372,2.372,0,0,1-.089.3,2.347,2.347,0,0,1-.11.248,2.867,2.867,0,0,1-.177.309c-0.051.078-.108,0.155-0.168,0.231a4.1,4.1,0,0,1-.278.328c-0.062.067-.13,0.132-0.2,0.2-0.125.119-.256,0.238-0.4,0.356-0.063.051-.13,0.1-0.2,0.151-0.173.13-.354,0.26-0.553,0.387-0.052.034-.108,0.067-0.162,0.1-0.229.141-.467,0.28-0.724,0.416l-0.1.052c-0.287.147-.588,0.293-0.909,0.433l-0.027.012a27.779,27.779,0,0,1-6.564,1.815l-0.039.006q-0.757.121-1.553,0.217c-0.087.009-.178,0.016-0.266,0.027-0.463.052-.933,0.1-1.416,0.139-0.22.018-.452,0.026-0.676,0.041-0.364.024-.724,0.049-1.1,0.064-0.609.02-1.23,0.034-1.864,0.034s-1.255-.014-1.864-0.037c-0.373-.014-0.732-0.041-1.1-0.064-0.225-.014-0.456-0.023-0.677-0.04-0.483-.039-0.952-0.088-1.416-0.14-0.087-.01-0.178-0.017-0.265-0.027q-0.8-.1-1.553-0.217l-0.04,0a27.8,27.8,0,0,1-6.563-1.815l-0.027-.012c-0.322-.141-0.623-0.286-0.91-0.434-0.033-.018-0.068-0.035-0.1-0.052-0.257-.135-0.5-0.273-0.724-0.415-0.054-.034-0.111-0.066-0.163-0.1-0.2-.127-0.379-0.256-0.553-0.387-0.065-.05-0.134-0.1-0.2-0.15-0.146-.118-0.277-0.237-0.4-0.357-0.068-.065-0.137-0.13-0.2-0.2-0.1-.109-0.193-0.218-0.279-0.328-0.059-.077-0.117-0.154-0.168-0.232a3.133,3.133,0,0,1-.176-0.308,2.544,2.544,0,0,1-.11-0.248,2.065,2.065,0,0,1-.089-0.305,1.487,1.487,0,0,1-.036-0.685,0.918,0.918,0,0,0-.024-0.373V635.2c0.092,0.091.2-.656,0.3-0.566,0.055,0.05.106,0.1,0.165,0.151,0.23,0.2.478,0.392,0.747,0.582,0.056,0.039.119,0.078,0.177,0.117q0.339,0.229.715,0.45c0.093,0.054.185,0.108,0.281,0.161,0.28,0.156.573,0.307,0.882,0.454,0.051,0.024.1,0.049,0.148,0.073,0.36,0.166.742,0.325,1.139,0.479,0.11,0.042.225,0.083,0.337,0.124,0.316,0.117.643,0.228,0.981,0.336,0.122,0.038.241,0.078,0.366,0.115,0.449,0.136.912,0.265,1.4,0.383,0.067,0.017.139,0.031,0.206,0.047q0.643,0.151,1.33.285c0.155,0.03.312,0.058,0.47,0.087q0.653,0.117,1.342.214c0.118,0.016.231,0.036,0.35,0.052q0.857,0.112,1.767.195c0.15,0.013.3,0.023,0.457,0.035q0.729,0.057,1.489.095l0.557,0.026c0.661,0.025,1.334.042,2.032,0.042s1.371-.017,2.032-0.042l0.557-.026q0.762-.037,1.489-0.095c0.152-.013.307-0.022,0.457-0.035,0.606-.054,1.2-0.12,1.767-0.195,0.12-.016.232-0.036,0.35-0.052q0.69-.1,1.342-0.214c0.158-.029.315-0.057,0.47-0.087,0.457-.089.9-0.184,1.33-0.285l0.206-.047c0.486-.118.95-0.248,1.4-0.383,0.125-.038.245-0.077,0.367-0.115,0.338-.108.664-0.219,0.98-0.336,0.113-.041.228-0.082,0.337-0.124,0.4-.154.78-0.313,1.139-0.479,0.051-.024.1-0.049,0.148-0.073,0.309-.148.6-0.3,0.882-0.454,0.1-.053.19-0.107,0.281-0.161,0.251-.146.49-0.3,0.715-0.45,0.058-.039.121-0.078,0.177-0.117q0.4-.285.748-0.582c0.057-.051.109-0.1,0.164-0.151C363.179,634.544,363.284,634.454,363.376,634.363Zm-17.633-8.61c10.392,0,17.633,3.306,17.633,6.274s-7.241,5.437-17.633,5.437S328.11,635,328.11,632.027,335.351,625.753,345.743,625.753Zm17.633,36.556a1.08,1.08,0,0,0-.024.113c-0.435,2.894-7.615,5.991-17.609,5.991s-17.174-3.1-17.608-5.991a0.96,0.96,0,0,0-.025-0.109v-6.2c0.021,0.022.048,0.043,0.07,0.064,0.168,0.161.338,0.321,0.53,0.475,2.888,2.383,8.663,4.235,17.033,4.235,8.335,0,14.1-1.837,17-4.206,0.232-.184.44-1.21,0.637-1.4v7.033Z"
                  transform="translate(-243 -621)"
                />
                <text
                  id="Identified_Online"
                  data-name="Identified Online"
                  class="cls-9"
                  transform="translate(205.72 15.324) scale(0.696 0.697)"
                >
                  {{ $t('identified-online') }}
                </text>
              </g>
            </svg>
          </div>
          <div class="col-sm-3 col-xl-2 info order-sm-2 order-xl-3">
            <span class="chart-title">{{ $t('identified-clients') }}</span>
            <div class="bar" :class="'bar-' + customersMatchRate"></div>
            <span class="percent data-value color-purple-200">{{ $_formatNumber(customersMatchRate, '0%') }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col text-center double-match">
            {{ $t('double-match') }}
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import getMetrics from '@/services/getmetrics';
import bus from '@/helpers/events/bus';
import { numberMixin } from '@/helpers/mixins';

export default {
  name: 'OmnichannelOverviewEcommerceInStore',
  mixins: [numberMixin],
  data() {
    return {
      totalUsers: undefined,
      identifiedUsers: undefined,
      usersMatchRate: undefined,
      purchases: undefined,
      identifiedPurchases: undefined,
      customersMatchRate: undefined,
      omniMatchRate: undefined,
    };
  },
  created() {
    this.fetch_data();
  },
  mounted() {
    bus.$on('render-cards', () => {
      this.fetch_data();
    });

    bus.$on('store-changed', value => {
      this.selectedStore = value;
      this.fetch_data();
    });
  },
  methods: {
    fetch_data() {
      getMetrics({
        metrics:
          'ec_users_total,ec_users_identified,ec_users_match_rate,visitors_off,customers_off_identified,customers_off_match_rate,on_off_match_rate',
        version: 2,
      }).then(response => {
        const { metrics } = response.data;

        if (
          !metrics ||
          !metrics.ec_users_total ||
          !metrics.ec_users_identified ||
          !metrics.ec_users_match_rate ||
          !metrics.visitors_off ||
          !metrics.customers_off_identified ||
          !metrics.customers_off_match_rate ||
          !metrics.on_off_match_rate
        ) {
          return;
        }

        this.totalUsers = metrics.ec_users_total.data.value.amount;
        this.identifiedUsers = metrics.ec_users_identified.data.value.amount;
        this.usersMatchRate = metrics.ec_users_match_rate.data.value.amount;
        this.purchases = metrics.visitors_off.data.value.amount;
        this.identifiedPurchases = metrics.customers_off_identified.data.value.amount;
        this.customersMatchRate = metrics.customers_off_match_rate.data.value.amount;
        this.omniMatchRate = metrics.on_off_match_rate.data.value.amount;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#OmnichannelOverviewEcommerceInStore {
  .row-graphic {
    margin-top: 20px;

    & > * {
      margin: 0;
      padding: 0;
    }

    .info {
      margin-top: 6px;

      &:first-child {
        margin-right: -1px;

        .bar:after {
          background-color: $oto-ecommerce;
        }
      }

      &:last-child {
        margin-left: -1px;

        .bar:after {
          background-color: $purple-200;
        }
      }
      .bar {
        background-color: #dbe6e4;
        height: 7px;
        width: 100%;
        border-radius: 4px;
        margin-bottom: 10px;
        overflow: hidden;

        &:after {
          content: '';
          background-color: #6c90f4;
          height: 100%;
          display: block;
          border-radius: 4px;
        }
      }
      @for $i from 0 through 100 {
        .bar-#{$i} {
          &:after {
            $value: ($i * 1%);
            width: $value;
          }
        }
      }
    }
  }

  svg {
    width: 100%;
    height: auto;

    @media (max-width: $tablet-max-width) {
      margin-top: 30px;
    }

    .cls-1 {
      fill: #c7c7c7;
      opacity: 0.8;
      @media (max-width: $tablet-max-width) {
        display: none;
      }
    }

    .cls-2,
    .cls-3,
    .cls-4 {
      fill: $purple-200;
    }

    .cls-2 {
      stroke: #2875c7;
    }

    .cls-2,
    .cls-8 {
      stroke-linejoin: round;
      stroke-width: 1px;
      fill-rule: evenodd;
    }

    .cls-3,
    .cls-9 {
      font-size: 17.214px;
    }

    .cls-3,
    .cls-7,
    .cls-9 {
      text-anchor: middle;
      font-weight: 700;
    }

    .cls-5,
    .cls-8,
    .cls-9 {
      fill: #8941d0;
    }

    .cls-6 {
      fill: $oto-omni;
      filter: url(#filter);
    }

    .cls-7 {
      font-size: 22.23px;
      fill: $color-white;
    }

    .cls-8 {
      stroke: #8941d0;
    }
  }
  .double-match {
    color: $purple-400;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    margin-top: 5px;
    margin-left: -5px;
  }
}
</style>
